<template>
    <div class="activity">
        <a class="item" href="#" :style="`background: ${color}`">
            <div class="image">
                <img :src="preview_url_optimized" alt="">
            </div>
            <div class="info" :style="`color: ${color}`">
                <div class="type">Warmup</div>
            </div>
            <div class="title">
                <h6>Backpack Exercise</h6>
                <div class="arrow" :style="`color: ${color}`">
                    <i class="dfcicon-arrow-right"></i>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
export default {
    name: "Activity",
    props: {
        color: {
            type: String,
        }
    },

    computed: {
        preview_url_optimized(){
            return '/img/resize/w600/h400/activities-preview%2FCGsmJtgfPr4hpPxkCtr3HsqHQUzptX6mnRYlGaTE.jpg';
        }
    }

}
</script>

<style lang="scss" scoped>
.activity{
    display: flex;
    align-items: stretch;
}

.item{
    display: flex;
    width: 100%;
    flex-direction: column;
    border-radius: .3rem;
    box-shadow: rgba(black, 0.1) 0 3px 5px;
    transition: background .5s;
    text-decoration: none;
    color: $dark;

    &:hover{
        .title{
            color: white;
        }

        .arrow{
            color: white !important;
            transform: rotateZ(90deg);
        }

        .image{
            img{
                transform: scale(1.1);
            }
        }

        .info{
            color: white !important;
        }

    }

    &:not(:hover){
        background: white !important;
    }

}

.image{
    height: 200px;
    border-radius: .3rem .3rem 0 0;
    overflow: hidden;

    img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform .5s;
    }
}

.info{
    display: flex;
    padding: 0.8rem 0.8rem 0.3rem;

    .type{
        font-size: .9em;
        font-weight: $font-weight-semibold;
    }
}

.title{
    flex-grow: 1;
    padding: 0.3rem 0.8rem 2rem;
    position: relative;

    h6{
        font-size: 1.6rem;
        margin-bottom: 0;
    }
}

.arrow{
    position: absolute;
    right: .6rem;
    bottom: .6rem;
    transform-origin: center;
    transition: transform .5s;
    font-size: 1.3rem;
    line-height: 0;
}

</style>
